import { Typography } from '@mui/material';

interface Props {
  note?: string | null;
  dark?: boolean;
}

export default function EventRemarkLine({ note, dark }: Props) {
  const text = note?.trim();
  if (!text) return null;

  return (
    <Typography
      variant="caption"
      color={dark ? 'rgba(255,255,255,0.6)' : 'text.secondary'}
      sx={{ display: 'block', fontStyle: 'italic' }}
    >
      備註：{text}
    </Typography>
  );
}
